import React,{useEffect , useState, useContext} from "react";
import { useNavigate } from "react-router-dom";
import { VectorMap } from "@react-jvectormap/core";
import { worldMill } from "@react-jvectormap/world";
import FetchUtil from "../../utils/FetchUtil";
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import "flag-icons/css/flag-icons.min.css";
import CompanySubscriptionModal from "../../components/CompanySubscriptionModal";
import UserContext from "../../contexts/UserContext";


  let country_colors = {};
  let availableCountries = [];
  let subscriberCountries = [];
  let accessibleCountries = [];
  let countryOptions = [];
  let countries = [];
  
  const ddStyles = {
  control: styles => ({ ...styles, backgroundColor: 'white', borderRadius: '10px', 
  lineHeight : '25px', minHeight : '30px', height : '35px', fontSize : '16px', verticalAlign: 'middle'}),
  option: (styles, state) => {
    return {
      ...styles,
      lineHeight : '25px', height : '35px', fontSize : '16px',
      fontWeight: state.isSelected ? "bold" : "normal",
    };
  },
  singleValue: (styles, state) => ({
      ...styles,
      lineHeight : '25px', height : '35px', fontSize : '16px', marginTop : '4px',
    }),
    indicatorSeparator: (styles, state) => ({
      ...styles,
      lineHeight : '25px', height : '30px', fontSize : '16px', marginTop : '0px',
    }),
    indicatorContainer: (styles, state) => ({
      ...styles,
      lineHeight : '25px', height : '30px', fontSize : '16px', marginTop : '4px',
    }),
    indicatorsContainer: (styles, state) => ({
      ...styles,
      lineHeight : '25px', height : '30px', fontSize : '16px', marginTop : '4px',
    }),
    container: (styles, state) => ({
      ...styles,
      lineHeight : '25px', height : '35px', fontSize : '16px', width: '50vw', whiteSpace: 'nowrap',
    }),
    input: (styles, state) => ({
      ...styles,
      lineHeight : '25px', height : '30px', fontSize : '16px',
    }),
    placeholder: (styles, state) => ({
      ...styles,
      lineHeight : '25px', height : '30px', fontSize : '16px', marginTop : '0px',
    }),
}
  
function Countries() {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const [error, setError] = useState(null);
	const [countryColors, setCountryColors] = useState({});
	const [showSubMsg, setShowSubMsg] = useState(false);
	const [scale, setScale] = useState({'1' : '#d9534f', '2' :  '#0079c3'});
	const [options, setOptions] = useState([]);
	const userCtx = useContext(UserContext);
	let canRead = false;
	if(userCtx){
		canRead = userCtx.isSubscriptionValid;
	}

	useEffect(() => {
		fetchCountries();
	}, []);
	
	function setCountryValues(countryObj){
		setOptions([]);
		let countryOptionValue = {};
		let label = '';
		countryOptions = [];
		if(countryObj && countryObj.length > 0){
			countryObj.map( (country, index) =>{
				if(country.published && (country.statusCode === 1) ){
					label = country.countryName;
					availableCountries.push(country.name);
					if (country.requireSubscription && !canRead) {
						label = country.countryName + ' $';
				        subscriberCountries.push(country.name);
				        country_colors[country.name] = 1;
			      	} else {
			        	country_colors[country.name] = 2;
			      	}
			      	if(canRead){
						accessibleCountries.push(country.name);
					}
					countryOptionValue.label = label;
					countryOptionValue.value = country.countryId + "-"+country.name;
					countryOptions.push(countryOptionValue);
					countryOptionValue = {};
				}
			});
		}
		setOptions(countryOptions.slice());
		setCountryColors({...country_colors});
	}
	
	function fetchCountries() {
	    const requestOptions = {
	      credentials: "same-origin",
	      method: "POST",
	      headers: { "Content-Type": "application/json" },
	      body: JSON.stringify({ source: "web"}),
	    };
	    try{
		   FetchUtil.fetchAPI("GetCountries","/Service/StaticHelper/GetCountries", requestOptions, getCountriesSuccess, getCountriesFail);
		} catch (error) {
		   setError(error.message);
		}
	}
  
  	function getCountriesFail(redirect){
  	  setError(t("error.getCountryFailed"));
  	}
  
  	function getCountriesSuccess(responseData){
	  	var countriesResponse;
	  	countries = [];
	  	if (responseData) {
	    	countriesResponse = responseData.getCountriesResponse;
	     	if (countriesResponse && countriesResponse.errorCode === "0") {
				countries = countriesResponse.countries.slice();
	       		setCountryValues(countriesResponse.countries);
	      	} else if (countriesResponse){
		    	setError(t("error.error") + " " +countriesResponse.errorMessage);
	      	}
	 	 }
	}
	function subscribePopupMsg(display){
		if(display){
			document.getElementById("page").classList.add("no-pointer");
			setShowSubMsg(true);
		}else{
			document.getElementById("page").classList.remove("no-pointer");
			setShowSubMsg(false);
		}
	}
	
	const handleChange = (selectedOption) => {
		let values = selectedOption.value.split('-');
	   	let code = values[1];
	   	if (subscriberCountries.includes(code)  && !accessibleCountries.includes(code)) {
            	subscribePopupMsg(true);
        } else {
	    	navigate('/countries/' + code.toLowerCase());
       	}
	};
	const handleOnRegionClick = (e, code, region)  =>{
		document.querySelectorAll('.jvectormap-tip').forEach((element) => { element.remove(); });
		if (!availableCountries.includes(code)) {
			e.preventDefault();
        } else {
			if (subscriberCountries.includes(code) && !accessibleCountries.includes(code) ) {
            	e.preventDefault();
            	subscribePopupMsg(true);
          	} else {
            	navigate('/countries/' + code.toLowerCase());
          	}
        }
	}
	
  	return (
		<div id="page">
			 {(error) && (
		        <div id="inerrorMessage" className="alert.alert-danger">
		          {error}
		        </div>
		      )}
		     <div className="page-inner">
			     <Select
			         name="country"
				     onChange={handleChange}
		        	 options={options}
		        	 placeholder="Search for a country"
		        	 isSearchable={true}
		        	 className="myselect"
		        	 styles={ddStyles}
		         />
		    </div>
		    <br />
		    <VectorMap map={worldMill}
		        containerStyle={{
                       width: '100vw',
                       height: '70vh'
                   }}
		    	style={{ width: "100vw", height: "70vh", margin: "0 auto" }}
		    	backgroundColor={'#bbd6ed'}
      			borderColor={'#818181'}
      			borderOpacity={0.25}
      			selectedColor={'#004365'}
      			series={{
			      regions: [
			        {
			          attribute: 'fill',
			          normalizeFunction: undefined,
			          scale: scale,
			          values: countryColors,
			         }
			      ]
			    }}
			    regionStyle={{
					initial:{
						fill : '#f4f3f0',
					}
				}}
				onRegionTipShow={
					function(event, label, code){
						var text = label.text();
				        var subscriber_only_label = '';
				        if (!availableCountries.includes(code)) {
				          label.html('<span class="fi fi-'+code.toLowerCase()+'"></span><br/><span>' + text + '</span><br/><b>Profile not yet available</b>');
				        } else {
							if (subscriberCountries.includes(code)){
								subscriber_only_label += '<span style="font-size: 13px; margin-left: 5px;" class="label label-success">$</span>'
							}
			          		label.html('<span class="fi fi-'+code.toLowerCase()+'"></span><br/><span>' + text + subscriber_only_label + '</span><br/><b>Click to view profile</b>');
				        }
		      		}
		      	}
		      	onRegionClick={(event, code, region) => handleOnRegionClick(event, code, region)}
      		/>
      		{showSubMsg && <CompanySubscriptionModal setShow={subscribePopupMsg} />}
        </div>
  );
}
export default Countries;
